export const MENU_SECTIONS = [
    { name: 'Breakfast', sortOrder: 1, hint: 'Idli, dosa, poha, eggs, toast — served up to mid-morning' },
    { name: 'Soups', sortOrder: 2, hint: 'Soups and shorbas, served first' },
    { name: 'Starters', sortOrder: 3, hint: 'Tikka, kebab, tandoori, fried snacks, chaat' },
    { name: 'Fast Food', sortOrder: 4, hint: 'Burgers, pizza, rolls, sandwiches, fries' },
    { name: 'Main Course', sortOrder: 5, hint: 'Curries and gravies, veg and non-veg' },
    { name: 'Breads', sortOrder: 6, hint: 'Roti, naan, kulcha, paratha' },
    { name: 'Rice & Biryani', sortOrder: 7, hint: 'Biryani, pulao, fried rice, steamed rice' },
    { name: 'Thali & Combos', sortOrder: 8, hint: 'Full meals and set combinations' },
    { name: 'Accompaniments', sortOrder: 9, hint: 'Raita, papad, pickle, salad, curd' },
    { name: 'Desserts', sortOrder: 10, hint: 'Gulab jamun, halwa, ice cream, cakes' },
    { name: 'Beverages', sortOrder: 11, hint: 'Chai, coffee, juices, mocktails, water' },
];
export const MENU_SECTION_NAMES = MENU_SECTIONS.map((s) => s.name);
/** Sections come first, in card order; a hotel's own follow, alphabetically. */
const CUSTOM_BASE = 1000;
export function sectionRank(category) {
    const name = category.trim().toLowerCase();
    const found = MENU_SECTIONS.findIndex((section) => section.name.toLowerCase() === name);
    return found === -1 ? CUSTOM_BASE : found;
}
export const isStandardSection = (category) => sectionRank(category) !== CUSTOM_BASE;
/**
 * Category names in the order every screen should show them.
 *
 * One comparison, used by the till, the menu screen and the guest card, so a
 * cashier who learns where starters live on one screen finds them in the same
 * place on the next.
 */
export function sortCategories(categories) {
    return [...categories].sort((a, b) => {
        const rank = sectionRank(a) - sectionRank(b);
        return rank !== 0 ? rank : a.localeCompare(b);
    });
}
/** The same order, for anything carrying a category alongside other fields. */
export function byCategory(item, category) {
    return { rank: sectionRank(category(item)), name: category(item) };
}
export function compareByCategory(read) {
    return (a, b) => {
        const rank = sectionRank(read(a)) - sectionRank(read(b));
        return rank !== 0 ? rank : read(a).localeCompare(read(b));
    };
}
// ------------------------------------------------- clubbing an old menu ----
/**
 * The words hotels use for their sections, and where each belongs.
 *
 * Menus written before there were standard sections - and menus typed by an
 * owner who calls the same food something else - carry names like "Indian
 * Mains" or "Veg Starters". Each is matched as a whole word, so "Bar Bites"
 * does not become a bread on the strength of a few shared letters.
 */
const SECTION_WORDS = [
    ['breakfast', 'Breakfast'],
    ['tiffin', 'Breakfast'],
    ['dosa', 'Breakfast'],
    ['idli', 'Breakfast'],
    ['omelette', 'Breakfast'],
    ['soup', 'Soups'],
    ['soups', 'Soups'],
    ['shorba', 'Soups'],
    ['starter', 'Starters'],
    ['starters', 'Starters'],
    ['appetiser', 'Starters'],
    ['appetisers', 'Starters'],
    ['appetizer', 'Starters'],
    ['appetizers', 'Starters'],
    ['snack', 'Starters'],
    ['snacks', 'Starters'],
    ['tandoor', 'Starters'],
    ['tandoori', 'Starters'],
    ['kebab', 'Starters'],
    ['kebabs', 'Starters'],
    ['tikka', 'Starters'],
    ['chaat', 'Starters'],
    ['burger', 'Fast Food'],
    ['burgers', 'Fast Food'],
    ['pizza', 'Fast Food'],
    ['pizzas', 'Fast Food'],
    ['roll', 'Fast Food'],
    ['rolls', 'Fast Food'],
    ['wrap', 'Fast Food'],
    ['wraps', 'Fast Food'],
    ['sandwich', 'Fast Food'],
    ['sandwiches', 'Fast Food'],
    ['fries', 'Fast Food'],
    ['main', 'Main Course'],
    ['mains', 'Main Course'],
    ['curry', 'Main Course'],
    ['curries', 'Main Course'],
    ['gravy', 'Main Course'],
    ['gravies', 'Main Course'],
    ['sabzi', 'Main Course'],
    ['noodles', 'Main Course'],
    ['bread', 'Breads'],
    ['breads', 'Breads'],
    ['roti', 'Breads'],
    ['rotis', 'Breads'],
    ['naan', 'Breads'],
    ['paratha', 'Breads'],
    ['parathas', 'Breads'],
    ['kulcha', 'Breads'],
    ['rice', 'Rice & Biryani'],
    ['biryani', 'Rice & Biryani'],
    ['biriyani', 'Rice & Biryani'],
    ['pulao', 'Rice & Biryani'],
    ['thali', 'Thali & Combos'],
    ['thalis', 'Thali & Combos'],
    ['combo', 'Thali & Combos'],
    ['combos', 'Thali & Combos'],
    ['meal', 'Thali & Combos'],
    ['meals', 'Thali & Combos'],
    ['raita', 'Accompaniments'],
    ['salad', 'Accompaniments'],
    ['salads', 'Accompaniments'],
    ['papad', 'Accompaniments'],
    ['pickle', 'Accompaniments'],
    ['curd', 'Accompaniments'],
    ['side', 'Accompaniments'],
    ['sides', 'Accompaniments'],
    ['accompaniment', 'Accompaniments'],
    ['accompaniments', 'Accompaniments'],
    ['dessert', 'Desserts'],
    ['desserts', 'Desserts'],
    ['sweet', 'Desserts'],
    ['sweets', 'Desserts'],
    ['icecream', 'Desserts'],
    ['brownie', 'Desserts'],
    ['brownies', 'Desserts'],
    ['beverage', 'Beverages'],
    ['beverages', 'Beverages'],
    ['drink', 'Beverages'],
    ['drinks', 'Beverages'],
    ['juice', 'Beverages'],
    ['juices', 'Beverages'],
    ['mocktail', 'Beverages'],
    ['mocktails', 'Beverages'],
    ['shake', 'Beverages'],
    ['shakes', 'Beverages'],
    ['tea', 'Beverages'],
    ['coffee', 'Beverages'],
    ['chai', 'Beverages'],
];
/**
 * Which standard section an existing category belongs under, or null.
 *
 * Null is the honest answer for anything unrecognised: a hotel that runs a
 * cigar counter keeps its cigar counter rather than having it filed under
 * something it is not. Nothing here renames anything by itself - it only
 * proposes, and `npm run menu:club-sections` reports before it writes.
 */
export function suggestSection(category) {
    const name = category.trim().toLowerCase();
    if (name === '')
        return null;
    const exact = MENU_SECTIONS.find((section) => section.name.toLowerCase() === name);
    if (exact)
        return exact.name;
    // Whole words only, and the last word wins: "South Indian Tiffin" is
    // breakfast, not a main course.
    const words = name.split(/[^a-z]+/).filter(Boolean);
    let match = null;
    for (const word of words) {
        const found = SECTION_WORDS.find(([token]) => token === word);
        if (found)
            match = found[1];
    }
    return match;
}
//# sourceMappingURL=menu-sections.js.map